import React, { useState } from "react";
import { Button, Form, Modal } from '@themesberg/react-bootstrap';
import { useCookies } from "react-cookie";
import { addPowerResults } from "../../../../../controller/api/gameResult";

export default (props) => {

  const [cookies] = useCookies(['lottmekong'])

  const [numbers, setNumbers] = useState(['', '', '', '', '', '', ''])
  const [jackpotPrize1, setJackpotPrize1] = useState('')
  const [jackpot1Winner, setJackpot1Winner] = useState('0')
  const [jackpotPrize2, setJackpotPrize2] = useState('')
  const [jackpot2Winner, setJackpot2Winner] = useState('0')

  const _onHide = () => {
    setNumbers(['', '', '', '', '', '', ''])
    setJackpotPrize1('')
    setJackpot1Winner('0')
    setJackpotPrize2('')
    setJackpot2Winner('0')
    props.onHide()
  }

  const handleNumberChange = (index, value) => {
    const newNumbers = [...numbers]
    newNumbers[index] = value
    setNumbers(newNumbers)
  }

  const onSubmit = async () => {
    const validNumbers = numbers.filter(n => n && n.length > 0)
    if (validNumbers.length !== 7) {
      alert('Vui lòng nhập đầy đủ 7 số (6 số chính + 1 số Power)')
      return
    }

    const jackpotValues = [
      jackpotPrize1,
      jackpot1Winner,
      jackpotPrize2,
      jackpot2Winner
    ]
    if (jackpotValues.some(value => !/^\d+$/.test(value))) {
      alert('Vui lòng nhập đầy đủ giá trị và số người trúng của cả hai Jackpot')
      return
    }

    const resp = await addPowerResults(cookies.lottmekong, {
      periodId: props.period.id,
      numbers,
      jackpotPrize1,
      jackpot1Winner: Number(jackpot1Winner),
      jackpotPrize2,
      jackpot2Winner: Number(jackpot2Winner)
    })
    if (resp) {
      window.location.reload()
    } else {
      alert('Có lỗi xảy ra')
      return false
    }
  }

  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      onHide={_onHide}
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Nhập kết quả Power 6/55 - Kỳ #{props.period && props.period.name}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          {[0, 1, 2, 3, 4, 5].map((idx) => (
            <Form.Group key={idx} className="mb-3">
              <Form.Label>Số {idx + 1}</Form.Label>
              <Form.Control
                type="text"
                placeholder={`Nhập số ${idx + 1}`}
                value={numbers[idx]}
                onChange={(e) => handleNumberChange(idx, e.target.value)}
              />
            </Form.Group>
          ))}
          <Form.Group className="mb-3">
            <Form.Label>Số Power</Form.Label>
            <Form.Control
              type="text"
              placeholder="Nhập số Power"
              value={numbers[6]}
              onChange={(e) => handleNumberChange(6, e.target.value)}
              style={{ backgroundColor: '#fff3cd', borderColor: '#ffc107' }}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Giá trị Jackpot 1 (đồng)</Form.Label>
            <Form.Control
              type="text"
              inputMode="numeric"
              placeholder="Nhập giá trị Jackpot 1 chính thức"
              value={jackpotPrize1}
              onChange={(e) => setJackpotPrize1(e.target.value)}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Số người trúng Jackpot 1</Form.Label>
            <Form.Control
              type="number"
              min="0"
              value={jackpot1Winner}
              onChange={(e) => setJackpot1Winner(e.target.value)}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Giá trị Jackpot 2 (đồng)</Form.Label>
            <Form.Control
              type="text"
              inputMode="numeric"
              placeholder="Nhập giá trị Jackpot 2 chính thức"
              value={jackpotPrize2}
              onChange={(e) => setJackpotPrize2(e.target.value)}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Số người trúng Jackpot 2</Form.Label>
            <Form.Control
              type="number"
              min="0"
              value={jackpot2Winner}
              onChange={(e) => setJackpot2Winner(e.target.value)}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={_onHide}>Close</Button>
        <Button variant="primary" onClick={onSubmit}>Thêm</Button>
      </Modal.Footer>
    </Modal>
  );
}
